import React , {useState,useEffect} from "react";

const useTopScroll = () => {
    useEffect(() => {
        window.scrollTo(0,0)
    },[])
}

export default useTopScroll